import axiosIns from '@/libs/axios'
import moment from 'moment'

const ROOT_URL = '/Admin/reports/general_reports'
export default {
  namespaced: true,
  state: {
    reportData: {
      countersData: [],
      chartData: {
        categories: [],
        series: [],
        years: [],
      },
    },
    filterParams: {
      sdate: null,
      edate: null,
    },
    summaryFilterParams: {
      counter_edate: moment().format('YYYY-MM-DD'),
    },
    loading: false,
  },
  getters: {
    reportData(state) {
      return state.reportData
    },
    filterParams(state) {
      return state.filterParams
    },
    summaryFilterParams(state) {
      return state.summaryFilterParams
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_REPORT_DATA(state, data) {
      state.reportData = data
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getReport({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}`, params)
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
  },
}
